type Props = {
  src: string;
  alt?: string;
  caption?: string;
  /** overall tilt of the polaroid (degrees) */
  rotate?: number;
  /** photo aspect ratio (e.g. '4/5', '1/1', '3/4') */
  aspect?: string;
  className?: string;
  /** drop-in animation delay (ms) */
  delay?: number;
  /** extra aria */
  loading?: 'eager' | 'lazy';
  /** tag shown above caption (e.g. "Nuntă") */
  tag?: string;
};

/**
 * Polaroid — a photo printed on cream paper.
 */
export function Polaroid({
  src,
  alt = '',
  caption,
  rotate = 0,
  aspect = '4/5',
  className = '',
  delay = 0,
  loading = 'lazy',
  tag,
}: Props) {
  const tilt = `rotate(${rotate}deg)`;

  return (
    <div
      className={`polaroid animate-polaroid-drop ${className}`}
      style={
        {
          transform: tilt,
          ['--tilt' as string]: tilt,
          ['--drop-delay' as string]: `${delay}ms`,
        } as React.CSSProperties
      }
    >
      <div className="photo">
        <img
          src={src}
          alt={alt}
          loading={loading}
          style={{ aspectRatio: aspect }}
        />
      </div>

      {tag && (
        <span
          className="absolute right-2 top-2 z-10 stamp"
          style={{ transform: 'rotate(3deg)' }}
        >
          {tag}
        </span>
      )}

      {caption && <p className="caption">{caption}</p>}
    </div>
  );
}
